import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { useSingleCache } from '@/data/hook/query/v2/useCacheManager';
import { courseLinesQueryKeys } from '@/data/services/querykeys';
import { CourseLine } from '@/models/CourseLine';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const useCourseLineWorkspace = () => {
  const { courseLineId: id } = useParams();
  const courseLineId = Number(id);
  const courseLineQueryKey = courseLinesQueryKeys.get(courseLineId);
  const { data: courseLine, isLoading: isLoadingCourseLine } = useQuery({
    ...courseLineQueryKey,
    enabled: !!courseLineId,
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });

  const cache = useSingleCache<CourseLine>(courseLineQueryKey.queryKey);

  const isLoading = isLoadingCourseLine && !!courseLineId;

  return {
    courseLine,
    isLoading,
    courseLineId,
    cache,
  };
};

export default useCourseLineWorkspace;
